/**
 * route.ts — where the public patient unlock page lives.
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: engagement unlock (2026-09-23).
 *
 * A CONSTANT, NOT A LITERAL, for the same reason as `marketing/route.ts` and
 * `safety/route.ts`: three places must agree on this path — the route table,
 * the tracking gate's `RESERVED_SEGMENTS` (a single-segment path is otherwise
 * read as a clinic slug and loads GTM) and the link clinic-service puts in
 * every engagement email and WhatsApp copy payload
 * (`${PORTAL_BASE_URL}/unlock#t=<token>`). A segment list that disagrees with
 * the route table by one letter fails silently: the page still renders, it
 * just renders with ad-tech on it — on a page reached from a named patient's
 * own inbox, holding a capability token in its fragment.
 *
 * ⚠️ The EMAIL side of this path is owned by clinic-service, not this file. If
 * it ever moves, the old path has to keep working (a redirect like the
 * clinical-safety misspelling), because unlock links live for 90 days in
 * people's inboxes and WhatsApp threads.
 */
export const UNLOCK_PATH = '/unlock';
